module.exports = __webpack_public_path__ + "static/media/spot10.116c04a1.webp";